module.exports = __webpack_public_path__ + "img/creative-commons-sa-icon.929945f4.svg";